import React from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

export default ({
  minValue = "",
  maxValue = "",
  marks = null,
  steps = null,
  style = null,
  onChange,
  name = "",
  onAfterChange,
  value = 0,
  disabled = false,
  className = "",
  handleStyle = [{}],
  trackStyle = [{}],
  dotStyle = {},
  activeDotStyle = {},
}) => {
  return (
    <Slider
      className={className}
      min={minValue}
      max={maxValue}
      value={value}
      marks={marks}
      step={steps}
      style={style}
      onChange={onChange}
      name={name}
      onAfterChange={onAfterChange}
      disabled={disabled}
      handleStyle={handleStyle}
      trackStyle={trackStyle}
      dotStyle={dotStyle}
      activeDotStyle={activeDotStyle}
    />
  );
};
